function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useContext } from 'react';
import TCell from "./TCell";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { TableRow, IconButton, Collapse, Checkbox } from '@mui/material';
import TableContext from "./context";
var RowContent = function RowContent(_ref) {
  var _rowSelection$selecte, _rowSelection$getChec;
  var row = _ref.row,
    index = _ref.index;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useContext = useContext(TableContext),
    dataSource = _useContext.dataSource,
    columns = _useContext.columns,
    size = _useContext.size,
    rowKey = _useContext.rowKey,
    rowSelection = _useContext.rowSelection,
    expandable = _useContext.expandable;
  var showExpand = expandable === null || expandable === void 0 ? void 0 : expandable.rowExpandable(row);
  var onAddSelectedRowKey = function onAddSelectedRowKey(key) {
    var _rowSelection$onChang;
    var cur = [].concat(_toConsumableArray((rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.selectedRowKeys) || []), [key]);
    rowSelection === null || rowSelection === void 0 ? void 0 : (_rowSelection$onChang = rowSelection.onChange) === null || _rowSelection$onChang === void 0 ? void 0 : _rowSelection$onChang.call(rowSelection, cur, cur.map(function (key) {
      return dataSource.find(function (data) {
        return data[rowKey] === key;
      });
    }));
  };
  var onRemoveSelectedRowKey = function onRemoveSelectedRowKey(key) {
    var _rowSelection$onChang2;
    var cur = ((rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.selectedRowKeys) || []).filter(function (item) {
      return item !== key;
    });
    rowSelection === null || rowSelection === void 0 ? void 0 : (_rowSelection$onChang2 = rowSelection.onChange) === null || _rowSelection$onChang2 === void 0 ? void 0 : _rowSelection$onChang2.call(rowSelection, cur, cur.map(function (key) {
      return dataSource.find(function (data) {
        return data[rowKey] === key;
      });
    }));
  };
  var onSelectedChange = function onSelectedChange(event) {
    if (event.target.checked) {
      onAddSelectedRowKey(row[rowKey]);
    } else {
      onRemoveSelectedRowKey(row[rowKey]);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, rowSelection && /*#__PURE__*/React.createElement(TCell, {
    size: size,
    sx: {
      paddingInlineStart: 1,
      width: 64
    }
  }, /*#__PURE__*/React.createElement(Checkbox, _extends({
    sx: {
      color: 'text.auxiliary'
    },
    size: "small",
    onChange: onSelectedChange,
    checked: rowSelection === null || rowSelection === void 0 ? void 0 : (_rowSelection$selecte = rowSelection.selectedRowKeys) === null || _rowSelection$selecte === void 0 ? void 0 : _rowSelection$selecte.includes(row[rowKey])
  }, rowSelection === null || rowSelection === void 0 ? void 0 : (_rowSelection$getChec = rowSelection.getCheckboxProps) === null || _rowSelection$getChec === void 0 ? void 0 : _rowSelection$getChec.call(rowSelection, row)))), showExpand && /*#__PURE__*/React.createElement(TCell, {
    size: size
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, open ? /*#__PURE__*/React.createElement(KeyboardArrowUpIcon, null) : /*#__PURE__*/React.createElement(KeyboardArrowDownIcon, null))), columns.map(function (column) {
    var _column$render;
    var value = row[column.dataIndex];
    var dom = ((_column$render = column.render) === null || _column$render === void 0 ? void 0 : _column$render.call(column, value, row, index)) || value;
    return /*#__PURE__*/React.createElement(TCell, {
      key: column.dataIndex,
      size: size,
      sx: {
        width: column.width,
        minWidth: column.minWidth
      }
    }, dom);
  }), showExpand && /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TCell, {
    style: {
      paddingBottom: 0,
      paddingTop: 0
    },
    colSpan: columns.length + 1,
    size: size
  }, /*#__PURE__*/React.createElement(Collapse, {
    in: open,
    timeout: "auto",
    unmountOnExit: true
  }, expandable === null || expandable === void 0 ? void 0 : expandable.expandedRowRender(row)))));
};
export default RowContent;